import { logger } from '@/lib/logger';
import { trackError } from '@/utils/errors';

// https://github.com/facebook/react/issues/11538#issuecomment-417504600
declare global {
  interface Node {
    removeChild<T extends Node>(child: T): T;
    insertBefore<T extends Node>(newNode: T, referenceNode: Node | null): T;
  }
}

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      logger.debug('Cannot remove a child from a different parent', child);
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      logger.debug('Cannot insert before a reference node from a different parent', referenceNode);
      trackError(new Error('Cannot insert before a reference node from a different parent'));
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
